import { Injectable } from '@angular/core';
import { BdbRequest, BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { Observable } from 'rxjs/Observable';
import { FingerprintLocalRequest } from '../../models/fingerprint-local-request.model';
import { environment } from '../../../../environments/environment';
import { SessionStorageKeysEnum } from '../../models/session-storage-keys-enum';
import HttpStatusCode from '../../enums/http-status.enum';
import { BdbRequestService } from '../../shared/bdb-request.service';
import { IResponseFromFetch } from '../../models/IResponseFromFetch';
import { ChannelService } from '../../shared/channel.service';
import axios from 'axios';
import { EventsService } from "../../shared/bdb-event.service";
import { ReportRequestEvent } from '../../models/report-event-request.model';
import { SandboxService } from '../../shared/sandbox/sandbox.service';
import { UUID } from 'angular2-uuid';

@Injectable()
export class AuthenticationRnecService {

    constructor(
        private readonly bdbSessionStorageService: BdbSessionStrgService,
        private readonly bdbRquest: BdbRequest,
        private readonly bdbRquestService: BdbRequestService,
        private readonly bdbSessionStrgService: BdbSessionStrgService,
        private readonly sandbox: SandboxService,
        private readonly channelService: ChannelService,
        private readonly bdbEventsService: EventsService
    ) { }

    regulationFromRnec(params: any) {
        const url = `${environment.sandboxV3Domain}/rnec/V2/get-format`
        return this.requestGetRencWithSandboxV3(url, params);
    }

    public async requestPostRencWithSandboxV3(body: any, url: string) {
        const documentNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const documentType = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        const newHeaders =
            this.bdbRquestService.getStandardizedHeadersForSandboxv3(documentType, documentNumber);
        Object.assign(newHeaders, { 'content-type': 'application/json' });
        delete newHeaders['Content-Type'];
        return this.sandbox.request('POST', {
            url,
            body,
            headers: newHeaders as any,
            uuid: newHeaders['X-RqUID']
        })
    }

    public async requestGetRencWithSandboxV3(url: any, body?: any) {
        const documentNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const documentType = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        const newHeaders =
            this.bdbRquestService.getStandardizedHeadersForSandboxv3(documentType, documentNumber);
        Object.assign(newHeaders, { 'content-type': 'application/json' });
        delete newHeaders['Content-Type'];
        return this.sandbox.request('GET', {
            url,
            headers: newHeaders as any,
            queryParams: body,
            uuid: newHeaders['X-RqUID'],
        })
    }

    public async OfficeDataByIP(privateIp: string): Promise<IResponseFromFetch> {
        if (environment.useMDMTVSEndpoint) {
            const headers = {
                'X-Name': 'Seguridad'
            }

            const url = `${environment.mdmBusinessInfoTVSEndpoint}/machine/ip/${privateIp}`;
            return this.sandbox.request('GET', {
                url,
                headers,
                uuid: UUID.UUID()
            });
        } else {
            return new Promise<any>((resolve, reject) => {
                fetch(`${environment.mdmBusinessInfoEndpoint}/getOfficeXIp?privateIp=${privateIp}`).then(async (res) => {
                    const bodyResponse = await res.json()
                    const response = { status: res.status, ...bodyResponse }
                    resolve(response);
                }).catch((reason) => {
                    reject(reason);
                })
            })
        }
    }

    async captureFingerprintWithLocalService(requestData: FingerprintLocalRequest) {
        const requestCaptureFingerprint = {
            SerialDispositivo: requestData.SerialDispositivo,
            NumeroDedo: requestData.NumeroDedo,
            TipoDedo: requestData.TipoDedo,
        }
        let isErrorAgentOlimpia = true;
        const onCaptureEvent = this.bdbSessionStrgService.get('onCaptureEvent');
        console.log('Valida evento onCaptureEvent --> ', !!onCaptureEvent)
        try {
            const response = await axios.post('https://localhost:5000/SolicitudOlimpia', requestCaptureFingerprint);
            console.log('status: ', response.status);
            console.log('Plain response from capture: ', response.data);
            isErrorAgentOlimpia = false;
            if (!onCaptureEvent) {
                this.bdbSessionStrgService.save('onCaptureEvent', 'true')
            }
            if (response.status === 200) {
                const responseObj = response.data;
                if (!!responseObj.Error || !!responseObj.DescripcionError) {
                    return {
                        successfulCapture: false,
                        errorCode: responseObj.Error || 'UNKNOWN',
                        errorDesc: responseObj.DescripcionError || 'UNKNOWN'
                    }
                } else if (responseObj.Respuesta && responseObj.Respuesta === 'OK') {
                    return {
                        successfulCapture: true,
                        errorCode: null,
                        errorDesc: null
                    }
                } else {
                    return {
                        successfulCapture: false,
                        errorCode: null,
                        errorDesc: null
                    }
                }
            } else {
                return {
                    successfulCapture: false,
                    errorCode: null,
                    errorDesc: null
                }
            }
        } catch (error) {
            console.error('Error in capture -->', error)
            if (isErrorAgentOlimpia) {
                if (!!onCaptureEvent) {
                    throw {
                        isErrorAgent: true,
                        isErrorOnOff: false
                    }
                } else {
                    this.bdbSessionStrgService.save('onCaptureEvent', 'true')
                    throw {
                        isErrorAgent: true,
                        isErrorOnOff: true
                    }
                }
            } else {
                throw {
                    isErrorAgent: false,
                }
            }
        }
    }

    async validateFingerprintsWithLocalService() {
        const documentNumber = this.bdbSessionStrgService.get('identityNumber');
        const requestValidateCapture = {
            login: "scanas",
            idOficina: "Oficina Olimpia",
            idProducto: 47,
            numeroDocumento: documentNumber,
            idCliente: 1024,
            convenio: 'F4C6C791-3AEB-425F-9B7B-A1A8C6C360B0'
        }

        try {
            const response = await axios.post('https://localhost:5000/Ingreso', requestValidateCapture);
            console.log('status: ', response.status);
            console.log('Plain response from validation: ', response.data);
            const responseObj = response.data;

            if (response.status !== 200) {
                return {
                    result: false,
                    hitStatus: '',
                    customerInfo: response
                }
            }

            if (responseObj.descripcionError && responseObj.descripcionError !== "0") {
                return {
                    result: false,
                    hitStatus: '',
                    customerInfo: responseObj
                }
            }

            if (responseObj.resultado) {
                return {
                    result: true,
                    hitStatus: responseObj.resultado,
                    customerInfo: responseObj
                }
            }

            return {
                result: false,
                hitStatus: '',
                customerInfo: responseObj
            }
        } catch (error) {
            return {
                result: false,
                hitStatus: '',
                customerInfo: error
            }
        }
    }

    getBodyRnecEvent(eventName: string, eventResult: string, hand: any, finger: any, olimpiaResult: any): ReportRequestEvent {
        const {
            AppName,
            journey,
            privateIp,
            product,
            specificProductInfoUuid } = this.bdbEventsService.getInfoDataToReport();
        const hardware = this.bdbSessionStrgService.get(SessionStorageKeysEnum.HARDWARE);
        const provider = !!hardware ? hardware === 'new' ? 'P80' : 'Samsung' : '';
        const latitud = +this.bdbSessionStrgService.get(SessionStorageKeysEnum.LATITUDE) || 0;
        const longitud = +this.bdbSessionStrgService.get(SessionStorageKeysEnum.LONGITUDE) || 0;
        return {
            appName: AppName,
            documentNumber: this.bdbSessionStrgService.get('identityNumber'),
            documentType: 'C',
            eventName: eventName,
            eventResult: eventResult,
            journey,
            latitud,
            longitud,
            ip: privateIp,
            officeCode: this.bdbSessionStrgService.get(SessionStorageKeysEnum.OFFICE_CODE),
            mediumType: this.bdbSessionStrgService.get(SessionStorageKeysEnum.MEDIUM_TYPE),
            finger: finger,
            hand: hand,
            expdate: this.bdbSessionStrgService.get(SessionStorageKeysEnum.EXPDATE),
            product,
            sellerIdentityType: this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_IDENTITY_TYPE),
            sellerDocumentNumber: this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER),
            sellerUsername: this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_USER_NAME),
            sellerIdentityNumberLdap: this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LDAP),
            specificProductInfoUuid,
            candidate: this.bdbSessionStrgService.get('candidate'), // json as a string
            uuidAuth: this.bdbSessionStrgService.get(SessionStorageKeysEnum.UUID_AUTH),
            provider,
            channel: this.channelService.getChannel(),
            olimpiaResult
        }
    }

    async reportAuthenticationEventSandboxV3(eventName: string, eventResult: string, hand: any, finger: any, olimpiaResult: any) {
        try {
            const reportRequest = this.getBodyRnecEvent(eventName, eventResult, hand, finger, olimpiaResult);
            const urlToSandbox = `${environment.sandboxV3Domain}/rnec/V2/report-biometric-authentication-event`;
            console.log('Report request body ------>', reportRequest, reportRequest.documentNumber, reportRequest.uuidAuth);
            const response = await this.requestPostRencWithSandboxV3(reportRequest, urlToSandbox);
            return {
                body: response.body,
                _body: JSON.stringify(response.body),
                status: response.status
            }
        } catch (error) {
            return {
                body: "",
                _body: JSON.stringify(""),
                status: 400
            }
        }
    }

    getOfficeInfo(officeCode: string): Promise<IResponseFromFetch> {
        if (environment.useMDMTVSEndpoint) {
            const headers = {
                'X-Name': 'Seguridad'
            }
            const url = `${environment.mdmBusinessInfoTVSEndpoint}/offices/${officeCode}`;
            return this.sandbox.request('GET', {
                url,
                headers,
                uuid: UUID.UUID()
            });
        } else {
            return new Promise<any>((resolve, reject) => {
                fetch(`${environment.endpointMdM}mdmBusinessInfo/getBDBOfficeByCode?code=${officeCode}`).then(async (res) => {
                    const bodyResponse = await res.json()
                    const response = { status: res.status, ...bodyResponse }
                    resolve(response);
                }).catch((reason) => {
                    console.log(reason);
                    reject(reason);
                })
            })
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/authentication-rnec/services/authentication-rnec.service.ts